module.exports = __webpack_public_path__ + "static/media/nintendo@2x.2db27126.jpg";